"use strict";
exports.__esModule = true;
// @ts-ignore
var nodeFetch = null;
// @ts-ignore
if (typeof EdgeRuntime !== 'string') {
    try {
        nodeFetch = require('node-fetch');
        var nfDefault = nodeFetch["default"];
        if (nfDefault && typeof nfDefault === 'function') {
            nodeFetch = nfDefault;
        }
    }
    catch (err) {
        // Ignore
    }
}
// @ts-ignore
function safeFetch() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (nodeFetch) {
        return nodeFetch.apply(void 0, args);
    }
    else {
        // @ts-ignore
        return fetch.apply(void 0, args);
    }
}
exports["default"] = safeFetch;
